import React from "react";
import PropTypes from "prop-types";

import MenuList from "ui/MenuList";
import NavRailMenuItem from "./NavRailMenuItem";

const NavRailContent = (props) => {
  const { items } = props;

  return (
    <MenuList className="nav-rail-content-list">
      {items.map((item, index) => {
        return (
          <NavRailMenuItem
            key={`nav-rail-menu-item-${index}`}
            link={item.link}
            title={item.title}
            Icon={item.Icon}
            permission={item.permission}
          />
        );
      })}
    </MenuList>
  );
};

NavRailContent.propTypes = {
  items: PropTypes.array.isRequired,
};

export default NavRailContent;
